/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Best_Feature_2Inputs */

const et_plan_best_feature_2 = /** @type {(inputs: Plan_Best_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iganädalased uuendused`)
};

const en_plan_best_feature_2 = /** @type {(inputs: Plan_Best_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly updates`)
};

/**
* | output |
* | --- |
* | "Weekly updates" |
*
* @param {Plan_Best_Feature_2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_best_feature_2 = /** @type {((inputs?: Plan_Best_Feature_2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Best_Feature_2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_best_feature_2(inputs)
	return en_plan_best_feature_2(inputs)
});